import { z } from "zod";

export const cardPaymentMethodSchema = z.object({
  line1: z.string(),
  line2: z.string().nullable(),
});

export type CardPaymentMethod = z.infer<typeof cardPaymentMethodSchema>;
